import React from "react"
import NestedRoute from "./NestedRoute"
import PartialRoute from "./PartialRoute"

// replace with NestedProps when we type nested route
interface NestedProps {
  [key: string]: any
}

interface ComponentProps {
  [key: string]: any
}

type AllowedRouteComponents = typeof NestedRoute | typeof PartialRoute

export default function <T = ComponentProps>(Component: React.ReactNode, nestedProps: NestedProps, componentProps: T) {
  return withRoute<T>(Component, nestedProps, componentProps, NestedRoute)
}

export function withPartialRoute<T = ComponentProps>(Component: React.ReactNode, nestedProps: NestedProps, componentProps: T) {
  return withRoute<T>(Component, nestedProps, componentProps, PartialRoute)
}

function withRoute<T>(Component: React.ReactNode, nestedProps: NestedProps, componentProps: T, RouteComponent: AllowedRouteComponents) {
  return function (props: NestedProps) {
    const path = `${props.match || ""}${props.path || ""}`
    return <RouteComponent {...props} {...nestedProps} path={path} component={Component} componentProps={{...componentProps, path}} />
  }
}
